/**
 * External dependencies
 */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Box, Stack } from '@towersystems/towersystems-design-system';
import { map } from 'lodash';

/**
 * Internal dependencies
 */
import { requestResources } from 'state/resources/actions';
import ResourceListTable from './resource-list-table';
import Search from 'components/search';
import Card from 'components/card';
import DropdownSelect from 'components/dropdown-select';
import SyncResourceModal from 'modules/dashboard/resources/sync-resource-modal';
import QueryConnections from 'data/query-connections';
import { getAllConnections } from 'state/connections/selectors';
import usePagination from 'modules/dashboard/pagination/use-pagination';
import ButtonGroup from 'components/button-group';
import Button from 'components/button';

/**
 * Style dependencies
 */
import './styles.scss';

const ResourcesList = ({ connections, ...props }) => {
   
    const { currentItems, requestItems, setCriteria, footer, isRequesting } = usePagination(props.requestResources, {
        orderBy: { updatedAt: 'desc' },
    });

    return (
        <Stack className='resources__list-wrapper' space='large'>
            <Card>
                <Box display='flex' width='full' padding='large'>
                    <Box display='flex' width='full'>
                        <Search
                            placeholder='Search resources'
                            onKeyPress={(e) => {
                                let criteria = setCriteria({ data: e.target.value });
                                requestItems({ criteria });
                            }}
                        />
                    </Box>
                    <Box display='flex' alignItems='center' paddingLeft='large'>
                        <ButtonGroup width="full">
                            <DropdownSelect
                                selected=''
                                onChange={(type) => {
                                    let criteria = setCriteria({ type });
                                    requestItems({ criteria });
                                }}
                                buttonRender={({ handleClick, title, label }) => (
                                    <Button style={{ width: 180 }} onClick={handleClick}>{title}</Button>
                                )}
                                options={[
                                    {
                                        value: '',
                                        label: 'All resource types',
                                    },
                                    {
                                        value: 'kits',
                                        label: 'Kits resources',
                                    },
                                    {
                                        value: 'product',
                                        label: 'Product resources',
                                    },
                                    {
                                        value: 'department',
                                        label: 'Department resources',
                                    },
                                    {
                                        value: 'category',
                                        label: 'Category resources',
                                    },
                                    {
                                        value: 'customer',
                                        label: 'Customer resources',
                                    },
                                ]}
                            />
                        </ButtonGroup>
                    </Box>
                </Box>
                <ResourceListTable resources={currentItems} isRequesting={isRequesting} />
            </Card>
            {footer}
            <SyncResourceModal />
            <QueryConnections />
        </Stack>
    );
};

export default connect(
    (state) => ({
        connections: getAllConnections(state),
    }),
    {
        requestResources,
    },
)(ResourcesList);
